import { useState } from "react";
import { Tabs, Tab, TabList, TabPanels, TabPanel } from "@chakra-ui/react";

export const TabsComponent = ({
  tabList,
  tabPanels,
  justifyContent = "flex-start",
  padding = "10px 0 0",
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  return (
    <Tabs onChange={handleTabChange} index={selectedTab} isLazy>
      <TabList
        style={{
          position: "sticky",
          top: "64px",
          zIndex: 1,
          justifyContent: "center",
          borderTop: "thin solid rgba(0, 176, 255, 0.4)",
          borderBottom: "thin solid rgba(0, 176, 255, 0.4)",
          background: "#fff",
          padding: padding,
        }}
      >
        {tabList.map((tab, index) => (
          <Tab
            key={index}
            onClick={handleTabChange.bind(null, index)}
            width="auto"
            textTransform="capitalize"
            fontWeight={600}
            pl="25px"
            pr="25px"
          >
            {tab.name}
          </Tab>
        ))}
      </TabList>

      <TabPanels>
        {tabPanels.length > 0 ? (
          tabPanels.map((tab, index) => (
            <TabPanel key={index} padding="0">
              {tab.panel}
            </TabPanel>
          ))
        ) : (
          <p>No tabs available</p>
        )}
      </TabPanels>
    </Tabs>
  );
};
